import _ from "lodash";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import Reports from "../../common/reports/Reports";
import Autocomplete from "../../framework/Autocomplete";
import Button from "../../framework/Button";
import GlobalContext from "../../framework/GlobalContext";
import Shortcut from "../../framework/Shortcut";
import classes from "./index.module.css";
import HsnReportFilter from "./HsnReportFilter";
import HsnReportSummary from "./HsnReportSummary";
import AddHsn from "./addHsn/index";

const Hsn = () => {
  const [showAddHsn, setShowAddHsn] = useState(false);
  const [hsnData, setHsnData] = useState(null);
  const [onFilterShow, setOnFilterShow] = useState(false);
  const [onColumnShow, setOnColumnShow] = useState(false);
  const [rowLevelCTAs, setRowLevelCTAs] = useState([]);
  const [filterStates, setFilterStates] = useState(null);
  const [refreshData, setRefreshData] = useState(false);
  const [filterParams, setFilterParams] = useState(null);
  const [currentRowData, setCurrentRowData] = useState(null);
  const { setCurrentComponent, currentComponent } = useContext(GlobalContext);
  const reportRef = useRef();
  const editRef = useRef();
  const refreshRef = useRef();


  const addHsn = useCallback((isEdit = false) => {
    if (isEdit) {
      setHsnData(reportRef.current.getCurrentRowData());
    }
    setShowAddHsn(true);
  }, []);

  const closeHsnAc = useCallback(() => {
    setShowAddHsn(false);
    setHsnData(null);
    setCurrentComponent("grid_reports");
  }, [setCurrentComponent]);

  const debouncecloseHsnAc = _.debounce(closeHsnAc, 200);

  const listener = useCallback(
    (e) => {
      const key = e.key?.toLowerCase();
      const ctrlKey = e.ctrlKey;
      const altKey = e.altKey;
      if (altKey && key === "r") {
        setRefreshData(true);
        return;
      }
      if (ctrlKey && key === "e") {
        if (currentRowData) return editRef.current.click();
      }
      if (ctrlKey && key === "h") {
        return addHsn();
      }
    },
    [addHsn, currentRowData]
  );

    const applyFilterHandler = useCallback((params, filterStates) => {
      setRefreshData(false);
      setFilterParams(params);
      setFilterStates(filterStates);
    }, []);

  useEffect(() => {
    const allRowCTAs = [
      <Button
        ref={editRef}
        startIcon={<Shortcut keys={["Ctrl", "E"]} />}
        label="Edit"
        onClick={() => {
          addHsn(true);
        }}
        isAccessible={currentRowData}
      />,
    ];
    setRowLevelCTAs(allRowCTAs);
  }, [addHsn, currentRowData]);

  useEffect(() => {
    if (
      !onFilterShow &&
      !showAddHsn &&
      !onColumnShow &&
      currentComponent === "grid_reports"
    ) {
      document.addEventListener("keyup", listener, false);
    }
    return () => {
      document.removeEventListener("keyup", listener, false);
    };
  }, [currentComponent, listener, onColumnShow, onFilterShow, showAddHsn]);
  return (
    <div className={classes["hsn-report-container"]}>
      <Reports
        identifier="hsn"
        reportRef={reportRef}
        rowLevelCTAs={rowLevelCTAs}
        filterStates={filterStates}
        filterParams={filterParams}
        onFilterShowClick={setOnFilterShow}
        onColumnShowClick={setOnColumnShow}
        filters={
          <HsnReportFilter
            reportRef={reportRef}
            filters={(filters) => {
              setFilterStates(filters);
            }}
            refreshData={refreshData}
            onFilterShow={onFilterShow}
            applyFilters={applyFilterHandler}
          />
        }
        currentRow={(data) => {
          setCurrentRowData(data);
        }}
      />
      <HsnReportSummary
         refreshData={() => {
          setRefreshData(true);
        }}
        refreshRef={refreshRef}
        showAutoComplete={() => {
          addHsn();
        }}
      />
      <Autocomplete
        show={showAddHsn}
        height="50%"
        width="50%"
        closeAutoComplete={debouncecloseHsnAc}
      >
        <AddHsn
          hsnData={hsnData}
          onEscape={debouncecloseHsnAc}
          onSaveHsn={() => {
            debouncecloseHsnAc();
            setRefreshData(true);
          }}
        />
      </Autocomplete>
    </div>
  );
};

export default Hsn;
